export const onlyAlphanumericRegex = /^[a-zA-Z0-9ñÑ\s]+$/;
export const NITValidationRegex = /^[89][0-9]{8}$/;
